// Returns the current timestamp
export default function () {
  return Date.now();
}
